export default __webpack_public_path__ + "static/media/confirm_relabel.9ebec0c6.svg";